import { PAGE_KEY } from './constants';

export const es = {
  [PAGE_KEY]: {
    // TIM-561 — bandeja de solicitudes: tabla + filtros
    SEO_TITLE: 'Solicitudes | Asistencia | Crehana',
    SEO_DESCRIPTION:
      'Revisa y responde las solicitudes de horas extra y tiempo a compensar de tus colaboradores.',

    BREADCRUMB_HOME: 'Inicio',
    BREADCRUMB_ATTENDANCE: 'Asistencia',
    BREADCRUMB_REQUESTS: 'Solicitudes',

    PAGE_TITLE: 'Solicitudes',
    PAGE_DESCRIPTION:
      'Revisa y responde las solicitudes de horas extra y tiempo a compensar de tus colaboradores.',

    TABLE_COLUMN_DATE: 'Fecha',
    TABLE_COLUMN_USER: 'Usuario',
    TABLE_COLUMN_SHIFT: 'Turno',
    TABLE_COLUMN_OVERTIME: 'Tiempo extra',
    TABLE_COLUMN_COMPENSATION: 'Tiempo de compensación',
    TABLE_COLUMN_REASON: 'Motivo',
    TABLE_COLUMN_STATUS: 'Estado',

    REQUEST_STATUS_PENDING: 'Pendiente',
    REQUEST_STATUS_APPROVED: 'Aprobada',
    REQUEST_STATUS_DENIED: 'Denegada',
    REQUEST_STATUS_UPDATED_TOOLTIP:
      'El tiempo final puede ser diferente al solicitado, ya que corresponde al tiempo registrado durante la jornada y a posibles ajustes realizados por el administrador.',

    REQUESTS_ACTION_VIEW_DETAIL: 'Ver detalle',
    REQUESTS_ACTION_RESPOND: 'Responder solicitud',

    REQUESTS_EMPTY_TITLE: 'Aún no hay solicitudes',
    REQUESTS_EMPTY_DESCRIPTION:
      'Las solicitudes de horas extra y reposición de tu equipo van a aparecer aquí.',
    REQUESTS_NO_RESULTS_TITLE: 'No hay resultados para mostrar',
    REQUESTS_NO_RESULTS_DESCRIPTION:
      'Inténtalo de nuevo con un filtro diferente.',

    FILTER_BUTTON_LABEL: 'Filtrar por',
    FILTER_ALL: 'Todos',
    FILTER_PANEL_LEGAL_ENTITY_LABEL: 'Razón Social',
    FILTER_PANEL_GROUP_LABEL: 'Grupos',
    FILTER_PANEL_POSITION_LABEL: 'Cargo',
    FILTER_PANEL_SHIFT_LABEL: 'Turno',
    FILTER_PANEL_LOCATION_LABEL: 'Lugar de marcaje',
    FILTER_PANEL_DEVICE_LABEL: 'Dispositivos',
    FILTER_PANEL_CLEAR: 'Borrar',
    FILTER_DATE_FROM_LABEL: 'Desde',
    FILTER_DATE_TO_LABEL: 'Hasta',
    FILTER_DATE_PLACEHOLDER: 'dd/mm/aaaa',

    ACTIONS_MENU_LABEL: 'Más opciones',
    ACTIONS_MENU_CANCEL: 'Cancelar',

    ERROR_TITLE: 'Algo salió mal',
    ERROR_DESCRIPTION: 'No pudimos cargar las solicitudes. Intenta de nuevo.',
    BUTTON_RETRY: 'Reintentar',

    // TIM-565 — drawer "Ver detalle"
    REQUEST_DETAIL_DRAWER_TITLE: 'Solicitud del {{date}}',
    REQUEST_DETAIL_TITLE_DATE_PATTERN: "d 'de' MMMM",
    REQUEST_DETAIL_CREATED_AT_LABEL: 'Fecha de solicitud',
    REQUEST_DETAIL_OVERTIME_REQUESTED_LABEL: 'Tiempo extra solicitado',
    REQUEST_DETAIL_COMPENSATION_REQUESTED_LABEL:
      'Tiempo de compensación solicitado',
    REQUEST_DETAIL_OVERTIME_FINAL_LABEL: 'Tiempo extra final',
    REQUEST_DETAIL_COMPENSATION_FINAL_LABEL: 'Tiempo de compensación final',
    REQUEST_DETAIL_RESPONDED_BY_LABEL: 'Respondido por',
    REQUEST_DETAIL_COMMENTS_SECTION_TITLE: 'Comentarios',
    REQUEST_DETAIL_COMMENTS_THREAD_TITLE: 'Hilo',
    REQUEST_DETAIL_COMMENTS_EMPTY: 'Aún no hay disponibles',
    REQUEST_DETAIL_COMMENTS_EMPTY_SUBTITLE:
      'Los comentarios que agregues sobre esta solicitud van a aparecer aquí.',
    REQUEST_DETAIL_COMMENTS_ERROR_DESCRIPTION:
      'No pudimos cargar los comentarios. Intenta de nuevo.',
    REQUEST_DETAIL_COMMENT_LABEL: 'Agregar comentario',
    REQUEST_DETAIL_COMMENT_PLACEHOLDER:
      'Utiliza este espacio para agregar comentarios sobre esta solicitud.',
    REQUEST_DETAIL_COMMENT_SUBMIT: 'Agregar comentario',
    VALIDATION_COMMENT_REQUIRED: 'Campo requerido.',
    VALIDATION_COMMENT_MAX_LENGTH: 'Máximo {{max}} caracteres.',

    // TIM-562 — dialog "Responder solicitud"
    RESPOND_DIALOG_TITLE: 'Responder solicitud',
    RESPOND_DIALOG_PROMPT:
      'Elige a continuación cómo deseas responder la solicitud:',
    RESPOND_DIALOG_APPROVE: 'Aprobar',
    RESPOND_DIALOG_DENY: 'Denegar',
    RESPOND_DIALOG_SURPLUS_AVAILABLE_LABEL: 'Tiempo excedente',
    RESPOND_DIALOG_SURPLUS_UNAVAILABLE: 'Aún no disponible',
    RESPOND_DIALOG_REQUESTED_OVERTIME_LABEL: 'Tiempo extra solicitado',
    RESPOND_DIALOG_REQUESTED_COMPENSATION_LABEL:
      'Tiempo de compensación solicitado',
    RESPOND_DIALOG_REASON_LABEL: 'Motivo de la respuesta',
    RESPOND_DIALOG_REASON_PLACEHOLDER: 'Indica el motivo de la respuesta',
    RESPOND_DIALOG_NO_SHIFT_BLOCK:
      'Antes de aprobar esta solicitud, asigna un turno a {{name}} para el {{date}}.',
    RESPOND_DIALOG_NO_SHIFT_DATE_PATTERN: "d 'de' MMMM 'de' yyyy",
    RESPOND_DIALOG_CONFIRM_APPROVE: 'Confirmar aprobación',
    RESPOND_DIALOG_CONFIRM_DENY: 'Confirmar denegación',
    VALIDATION_REASON_REQUIRED: 'Campo requerido.',
    VALIDATION_REASON_TOO_LONG: 'Máximo {{max}} caracteres.',
    TOAST_REQUEST_APPROVED: 'La solicitud fue aprobada.',
    TOAST_REQUEST_DENIED: 'La solicitud fue denegada.',
    TOAST_REQUEST_CONFLICT:
      'No es posible responder esta solicitud, parece que alguien más ya la resolvió.',
    TOAST_RESPOND_ERROR: 'No pudimos procesar tu solicitud. Intenta de nuevo.',
  },
};
